import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { bulletinsAPI, errMsg } from '../../lib/regulatoryAPI';

export const DraftActions = ({ d, meta, onChanged }) => {
  const [rejecting, setRejecting] = useState(false);
  const [reason, setReason] = useState('');
  const [type, setType] = useState(d.type);
  const act = async (action, r = '') => { try { await bulletinsAPI.draftAction(d.id, action, r); toast.success(`Draft ${action === 'submit' ? 'sent for review' : action + 'd'}`); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  const retype = async (t) => { setType(t); try { await bulletinsAPI.createDraft(d.bulletin_id, { type: t, title: d.title, content_html: d.content_html }); toast.success(`New ${t} draft created`); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  if (!meta.can_write) return null;
  return (
    <div className="ml-auto flex flex-wrap items-center gap-2">
      {['Draft', 'Rejected'].includes(d.status) && <Button size="sm" variant="outline" onClick={() => act('submit')} data-testid={`draft-submit-${d.id}`}>Submit for review</Button>}
      {meta.can_manage && d.status === 'Needs review' && <>
        <Button size="sm" onClick={() => act('approve')} data-testid={`draft-approve-${d.id}`}>Approve</Button>
        <Button size="sm" variant="destructive" onClick={() => setRejecting(true)} data-testid={`draft-reject-${d.id}`}>Reject</Button>
      </>}
      {meta.can_manage && ['Approved', 'Rejected'].includes(d.status) && <Button size="sm" variant="ghost" onClick={() => act('reopen')} data-testid={`draft-reopen-${d.id}`}>Reopen</Button>}
      <select className="h-8 rounded-md border bg-background px-2 text-xs" value={type} onChange={(e) => retype(e.target.value)} title="Create a copy as another type" data-testid={`draft-copy-as-${d.id}`}>
        {meta.draft_types.map((t) => <option key={t} value={t}>{t === d.type ? `Type: ${t}` : `Copy as ${t}`}</option>)}</select>
      {rejecting && <div className="flex w-full gap-2">
        <Input placeholder="Reason (required)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid={`draft-reject-reason-input-${d.id}`} />
        <Button size="sm" variant="destructive" disabled={!reason.trim()} onClick={() => act('reject', reason).then(() => setRejecting(false))} data-testid={`draft-reject-confirm-${d.id}`}>Confirm reject</Button>
      </div>}
    </div>
  );
};
